import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { EDocumentsStyled } from '../../asset/styled/EDocumentsStyled';

import titleImg from '../../asset/img/edocument_title_img.svg';
import arrowRight from '../../asset/img/common/arrow_right_primary_icon.svg';

import InfoBanner from '../../components/Banner';
import SubTitleSection from '../../components/SubTitleSection';
import Typography from '../../components/common/Typography';
import HousingFundsSection from './HousingFundsSection';

import GetDataSection from './GetDataSection';
import LinkToData from './linkToData';
import UploadPdf from './uploadPdf';
import {
  get100MillionCheck,
  getHousingFundsCheck,
  getPDFFileList,
  getPDFMainLoad,
  getPDFUploadFlag,
  resetEDocumentState,
} from './eDocumentsSlice';
import { processHousingFundsStatus } from './util';
import SlideDialogV from '../../components/common/SlideDialogV';
import WorkedMonthSection from './WorkedMonthSection';
import { nameRelation } from '../../common/Util';

const EDocuments = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('eDocuments');
  const { t: tDependents } = useTranslation('dependents');
  const [isLinkToDataOpen, setIsLinkToDataOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const { housingFundsCheckList, htm013, reload, uploadFlag, eDocumentStatus, htmMillionList } =
    useSelector(state => state.eDocuments);
  const { myInfo } = useSelector(state => state.myInfo);

  //일했던 월
  const [isSlideDialogVOpen, setIsSlideDialogVOpen] = useState(false);
  // 분양권의 경우는 장기주택, 주택임차 동시에X
  const [isSlideDialogVOpen2, setIsSlideDialogVOpen2] = useState(false);
  //분양권 한번 뜨면 안뜨게 처리하는 용도(Math.random() 사용)
  const [checkSlideDialogVOpen2, setCheckSlideDialogVOpen2] = useState(true);
  //100만원 이하 아닌데 체크한애들
  const [isSlideDialogVOpen3, setIsSlideDialogVOpen3] = useState(false);

  const [housingFundsStatus, setHousingFundsStatus] = useState({
    // htm102 : '', //주택임차   // 1 : 공제완료 2 : 공제불가 3 : 체크전
    // htm103 : '', //장기
    // htm104 : '', //주택마련
    // htm105 : '', //월세액
  });

  //초기 api 호출
  useEffect(() => {
    dispatch(getPDFUploadFlag()); //상세, 통합
    dispatch(getHousingFundsCheck()); //주택자금 체크유무
    dispatch(getPDFMainLoad()); //buttonFlag, 총금액, firstFlag, 이름 담는애
    dispatch(getPDFFileList()); // 파일리스트 담는애
    dispatch(get100MillionCheck()); // 100만원 이상인사람들 체크
    return () => {
      dispatch(resetEDocumentState());
    };
  }, []);

  //삭제, 저장 등 상태 변경 시 호출
  useEffect(() => {
    if (reload != -1) {
      dispatch(getPDFUploadFlag()); //상세, 통합
      dispatch(getHousingFundsCheck()); //주택자금 체크유무
      dispatch(getPDFMainLoad()); //buttonFlag, 총금액, firstFlag, 이름 담는애
      dispatch(getPDFFileList()); // 파일리스트 담는애
      dispatch(get100MillionCheck()); // 100만원 이상인사람들 체크
    }
  }, [reload, dispatch]);

  //housingFundsStatus 업데이트
  useEffect(() => {
    const newStatus = processHousingFundsStatus(housingFundsCheckList, htm013);
    setHousingFundsStatus(newStatus);
  }, [housingFundsCheckList]);

  //분양권 뜨는 팝업
  useEffect(() => {
    if (housingFundsStatus.htm102 === '1' && housingFundsStatus.htm103 === '1') {
      setIsSlideDialogVOpen2(true);
    }
  }, [housingFundsStatus]);

  //100만원 이하 아닌데 기본공제 체크한애들
  useEffect(() => {
    if (htmMillionList.length > 0) {
      setIsSlideDialogVOpen3(true);
    }
  }, [htmMillionList]);

  const bannerDescription = useMemo(() => {
    let htmPerNm = myInfo?.htmInsaPerNm;
    // flag1 : 중도입사자, flag2 : 계속 근로자
    let description = uploadFlag == 'D' ? t('bannerSection.flag1') : t('bannerSection.flag2');

    return `‘${htmPerNm}’${t('bannerSection.title')} ${description} ${t('bannerSection.title2')}`;
  }, [uploadFlag, eDocumentStatus]);

  const handleOpenClick = flag => {
    if (flag === 'upload') {
      setIsUploadOpen(true);
    } else {
      setIsLinkToDataOpen(true);
    }
  };

  //주택자금 전부없으면 렌더링 안 함
  const housingFundsStatusCheck = useMemo(() => {
    const keyList = ['htm102', 'htm103', 'htm104', 'htm105'];

    // housingFundsStatus에 keyList 중 하나라도 있으면 true
    return keyList.some(key => Object.hasOwn(housingFundsStatus, key));
  }, [housingFundsStatus]);

  return (
    <EDocumentsStyled>
      <InfoBanner title={t('mainBanner.title')} />
      <div
        className="displayFlex"
        style={{ justifyContent: 'flex-end', gap: '5px' }}
        onClick={() => setIsSlideDialogVOpen(true)}>
        <Typography variant="captionBold" color="Primary-500">
          {t('confirm')}{' '}
        </Typography>
        <img src={arrowRight} alt="arrowRight" />
      </div>
      <SubTitleSection title={t('title')} img={titleImg} />

      {/* 국세청연동, 파일 직접올릴게요~ */}
      <GetDataSection handleOpenClick={handleOpenClick} />
      {/* 주택자금 체크 */}
      {housingFundsStatusCheck && <HousingFundsSection {...{ housingFundsStatus }} />}

      {/* 국세청 연동 팝업 */}
      <LinkToData isOpen={isLinkToDataOpen} setIsOpen={setIsLinkToDataOpen} />
      {/* 파일업로드 팝업 */}
      <UploadPdf isOpen={isUploadOpen} setIsOpen={setIsUploadOpen} />

      {/* 일했던 월 */}
      <SlideDialogV
        isOpen={isSlideDialogVOpen}
        onClose={() => setIsSlideDialogVOpen(false)}
        title={t('confirm')}
        description={bannerDescription}
        innertComponent={<WorkedMonthSection />}
        style={{ padding: '30px 25px 50px 25px' }}
      />
      {/* 분양권의 경우는 장기주택, 주택임차 동시에X */}
      <SlideDialogV
        isOpen={isSlideDialogVOpen2 && checkSlideDialogVOpen2}
        onClose={() => {
          setIsSlideDialogVOpen2(false);
          setCheckSlideDialogVOpen2(false);
        }}
        title={t('slideDialog.title')}
        description={t('slideDialog.description')}
        buttons={[
          {
            label: t('slideDialog.button'),
            onClick: () => {
              setIsSlideDialogVOpen2(false);
              setCheckSlideDialogVOpen2(false);
            },
          },
        ]}
      />

      {/* 100만원 이하 아닌데 체크한애들  */}
      <SlideDialogV
        isOpen={isSlideDialogVOpen3}
        title={t('slideDialog2.title')}
        description={t('slideDialog2.description')}
        innertComponent={
          <div
            className="displayFlexColumn"
            style={{ gap: '4px', marginTop: '-20px', marginBottom: '30px' }}>
            {htmMillionList.map((item, index) => {
              console.log('item >>', item);
              console.log('nameRelation(tDependents, item) >>', nameRelation(tDependents, item));
              return (
                <Typography variant="body2Bold" key={index}>
                  {nameRelation(tDependents, item)}
                </Typography>
              );
            })}
          </div>
        }
        // innertComponent={<WorkedMonthSection />}
        style={{ padding: '30px 25px 50px 25px' }}
        buttons={[
          { label: t('slideDialog2.button'), onClick: () => setIsSlideDialogVOpen3(false) },
        ]}
      />
    </EDocumentsStyled>
  );
};

export default EDocuments;
